import { useContext, useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import SidBarClient from "../SideBarClient";
import { MagasinContext } from "../../../../Context/MagasinContext";
import axios from "axios";
import './setting.css';
import '../GlobalToast.css';

/* ────────────────────────────────────────────────────────────── */
/*  Inline styles (no extra CSS file needed)                      */
/* ────────────────────────────────────────────────────────────── */
const S = {
  page: {
    minHeight: "100vh",
    background: "linear-gradient(135deg,#f8faff 0%,#f1f5fb 100%)",
    paddingBottom: "60px",
  } as React.CSSProperties,
  inner: {
    maxWidth: "820px",
    margin: "0 auto",
    padding: "32px 18px 0",
  } as React.CSSProperties,
  card: {
    background: "#fff",
    borderRadius: "20px",
    boxShadow: "0 4px 24px rgba(0,0,0,0.07)",
    marginBottom: "20px",
    overflow: "hidden",
  } as React.CSSProperties,
  cardHead: {
    padding: "18px 24px",
    background: "linear-gradient(135deg,#1a1a2e,#16213e)",
    color: "#fff",
    fontWeight: 700,
    fontSize: "0.95rem",
    display: "flex",
    alignItems: "center",
    gap: "10px",
  } as React.CSSProperties,
  cardBody: { padding: "24px" } as React.CSSProperties,
  row: {
    display: "flex",
    gap: "16px",
    flexWrap: "wrap" as const,
    marginBottom: "16px",
  } as React.CSSProperties,
  formGroup: { display: "flex", flexDirection: "column" as const, flex: 1, minWidth: "220px" } as React.CSSProperties,
  label: { fontSize: "0.78rem", fontWeight: 700, color: "#64748b", marginBottom: "6px", textTransform: "uppercase" as const, letterSpacing: "0.05em" } as React.CSSProperties,
  input: {
    padding: "10px 14px",
    border: "1.5px solid #e2e8f0",
    borderRadius: "10px",
    fontSize: "0.92rem",
    color: "#1e293b",
    outline: "none",
    transition: "border 0.2s",
    background: "#fff",
  } as React.CSSProperties,
  inputReadOnly: {
    padding: "10px 14px",
    border: "1.5px solid #f1f5f9",
    borderRadius: "10px",
    fontSize: "0.92rem",
    color: "#94a3b8",
    background: "#f8fafc",
  } as React.CSSProperties,
  saveBtn: {
    background: "linear-gradient(135deg,#FFC300,#e6a800)",
    color: "#1a1a2e",
    border: "none",
    padding: "12px 32px",
    borderRadius: "12px",
    fontWeight: 700,
    fontSize: "0.92rem",
    cursor: "pointer",
    transition: "all 0.2s",
    display: "flex",
    alignItems: "center",
    gap: "8px",
  } as React.CSSProperties,
  linkBtn: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "14px 18px",
    borderRadius: "12px",
    border: "1.5px solid #e2e8f0",
    marginBottom: "10px",
    cursor: "pointer",
    transition: "all 0.2s",
    textDecoration: "none",
    color: "#1e293b",
    background: "#fff",
  } as React.CSSProperties,
  badge: {
    display: "inline-block",
    padding: "4px 12px",
    borderRadius: "20px",
    fontSize: "0.82rem",
    fontWeight: 700,
    background: "linear-gradient(135deg,#FFC300,#e6a800)",
    color: "#1a1a2e",
  } as React.CSSProperties,
};

/* ────────────────────────────────────────────────────────────── */

export default function SettingClient() {
  const magasinContext = useContext(MagasinContext);
  const ClientId   = localStorage.getItem("ClientId");
  const idClient   = ClientId || magasinContext.id?.id;
  const navigate   = useNavigate();

  /* ── profile data ── */
  const [nom,         setNom]         = useState("");
  const [adresse,     setAdresse]     = useState("");
  const [ice,         setIce]         = useState("");
  const [tele,        setTele]        = useState("");
  const [email,       setEmail]       = useState("");
  const [solde,       setSolde]       = useState<number | null>(null);
  const [remise,      setRemise]      = useState<string | null>(null);
  const [magasinLie,  setMagasinLie]  = useState<string | null>(null);
  const [imageUrl,    setImageUrl]    = useState<string | null>(null);
  const [imageFile,   setImageFile]   = useState<File | null>(null);
  const [imagePreview,setImagePreview]= useState<string | null>(null);

  /* ── UI state ── */
  const [loading,  setLoading]  = useState(true);
  const [saving,   setSaving]   = useState(false);
  const [toast,    setToast]    = useState<{ msg: string; ok: boolean } | null>(null);
  const fileRef = useRef<HTMLInputElement>(null);

  /* ── Security modals state ── */
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [newEmailInput, setNewEmailInput] = useState("");
  const [newPasswordInput, setNewPasswordInput] = useState("");
  const [submittingSecurity, setSubmittingSecurity] = useState(false);

  /* ── Load client profile ── */
  useEffect(() => {
    if (!idClient) return;
    axios
      .get(`${process.env.REACT_APP_PHP_APP_URL}/client/${idClient}/profile`)
      .then((res) => {
        const c = res.data?.client;
        if (c) {
          setNom(c.NomClient ?? "");
          setAdresse(c.Adresse ?? "");
          setIce(c.Ice ?? c.ICE ?? "");
          setTele(c.Tele ?? c.NumTele ?? "");
          setEmail(c.Email ?? c.EmailClient ?? "");
          setSolde(parseFloat(c.credit ?? c.Solde ?? c.Credit ?? "0") || 0);
          setRemise(c.RemiseGlobal ?? c.RemiseGlobale ?? null);
        }
        if (res.data?.magasin) {
          setMagasinLie(res.data.magasin.name ?? null);
        }
        if (res.data?.imageUrl) {
          setImageUrl(res.data.imageUrl);
        }
      })
      .catch(() => {
        /* fallback to localStorage */
        setNom(localStorage.getItem("ClientName") ?? "");
        const s = parseFloat(localStorage.getItem("SoldeClient") ?? "0");
        setSolde(isNaN(s) ? 0 : s);
      })
      .finally(() => setLoading(false));
  }, [idClient]);

  /* ── Image picker ── */
  const handleImagePick = (e: React.ChangeEvent<HTMLInputElement>) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setImageFile(f);
    const reader = new FileReader();
    reader.onload = () => setImagePreview(reader.result as string);
    reader.readAsDataURL(f);
  };

  /* ── Save profile ── */
  const handleSave = async () => {
    if (saving) return;
    setSaving(true);
    try {
      const fd = new FormData();
      fd.append("NomClient", nom);
      fd.append("Adresse",   adresse);
      fd.append("ICE",       ice);
      fd.append("NumTele",   tele);
      if (imageFile) fd.append("profile_image", imageFile);

      const res = await axios.post(
        `${process.env.REACT_APP_PHP_APP_URL}/client/${idClient}/update-profile`,
        fd,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (res.data?.imageUrl) {
        setImageUrl(res.data.imageUrl);
        setImagePreview(null);
        setImageFile(null);
      }
      showToast("Profil mis à jour avec succès ✓", true);
    } catch {
      showToast("Erreur lors de la mise à jour", false);
    } finally {
      setSaving(false);
    }
  };

  const showToast = (msg: string, ok: boolean) => {
    setToast({ msg, ok });
    setTimeout(() => setToast(null), 3500);
  };

  /* ── Security change request ── */
  const handleSecurityRequest = (type: 'change-email' | 'change-mot-de-passe') => {
    if (type === 'change-email' && !newEmailInput.trim()) return;
    if (type === 'change-mot-de-passe' && !newPasswordInput.trim()) return;
    setSubmittingSecurity(true);
    axios.post(`${process.env.REACT_APP_PHP_APP_URL}/client/${idClient}/security-request`, {
      demande: type,
      new_email: type === 'change-email' ? newEmailInput : null,
      new_password: type === 'change-mot-de-passe' ? newPasswordInput : null,
      userName: nom || 'Client',
      currentEmail: email || '',
    }).then(() => {
      showToast("Demande envoyée — en attente de validation par l'admin.", true);
      setShowEmailModal(false);
      setShowPasswordModal(false);
      setNewEmailInput('');
      setNewPasswordInput('');
    }).catch(() => {
      showToast("Erreur lors de l'envoi de la demande.", false);
    }).finally(() => setSubmittingSecurity(false));
  };

  const avatar = imagePreview ?? imageUrl;

  if (loading) {
    return (
      <div style={S.page}>
        <SidBarClient />
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}>
          <div className="spinner-border text-warning" />
        </div>
      </div>
    );
  }

  return (
    <div className="cl-setting-wrapper" style={S.page}>
      <SidBarClient />

      {/* ── Toast ── */}
      <div className="cl-toast-container">
        {toast && (
          <div className={`cl-toast ${toast.ok ? 'cl-toast--success' : 'cl-toast--error'}`}>
            <i className={`bi ${toast.ok ? 'bi-check-circle-fill' : 'bi-exclamation-triangle-fill'}`} />
            <span className="cl-toast-msg">{toast.msg}</span>
          </div>
        )}
      </div>

      <div className="cl-setting-inner" style={S.inner}>
        {/* Back */}
        <button
          onClick={() => window.history.back()}
          style={{ background: "none", border: "none", cursor: "pointer", color: "#64748b", fontWeight: 600, marginBottom: "20px", display: "flex", alignItems: "center", gap: "6px" }}
        >
          ← Retour
        </button>

        <h1 style={{ fontFamily: "'Inter', sans-serif", fontWeight: 800, fontSize: "1.6rem", color: "#1e293b", marginBottom: "24px" }}>
          Paramètres du compte
        </h1>

        {/* ── PROFILE PICTURE + ACCOUNT INFO ── */}
        <div style={S.card}>
          <div style={S.cardHead}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#FFC300" strokeWidth="2.5">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" />
            </svg>
            Profil
          </div>
          <div style={S.cardBody}>
            {/* Avatar */}
            <div style={{ display: "flex", alignItems: "center", gap: "22px", marginBottom: "28px" }}>
              <div style={{ position: "relative" }}>
                <div
                  style={{
                    width: "90px", height: "90px", borderRadius: "50%",
                    background: avatar ? "transparent" : "linear-gradient(135deg,#FFC300,#e6a800)",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    fontSize: "2.2rem", fontWeight: 800, color: "#1a1a2e",
                    overflow: "hidden",
                    boxShadow: "0 4px 16px rgba(255,195,0,0.35)",
                  }}
                >
                  {avatar
                    ? <img src={avatar} alt="avatar" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                    : nom.charAt(0).toUpperCase() || "C"}
                </div>
                <button
                  onClick={() => fileRef.current?.click()}
                  style={{
                    position: "absolute", bottom: 0, right: 0,
                    width: "28px", height: "28px", borderRadius: "50%",
                    background: "#1a1a2e", border: "2px solid #fff",
                    cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center",
                  }}
                  title="Changer la photo"
                >
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#FFC300" strokeWidth="2.5">
                    <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
                    <circle cx="12" cy="13" r="4" />
                  </svg>
                </button>
                <input ref={fileRef} type="file" accept="image/*" style={{ display: "none" }} onChange={handleImagePick} />
              </div>
              <div>
                <div style={{ fontWeight: 700, fontSize: "1.1rem", color: "#1e293b" }}>{nom || "—"}</div>
                <div style={{ color: "#64748b", fontSize: "0.85rem" }}>{email}</div>
                {magasinLie && (
                  <div style={{ marginTop: "6px" }}>
                    <span style={S.badge}>📦 {magasinLie}</span>
                  </div>
                )}
              </div>
            </div>

            {/* Editable fields */}
            <div style={S.row}>
              <div style={S.formGroup}>
                <label style={S.label}>Nom complet</label>
                <input
                  style={S.input}
                  value={nom}
                  onChange={(e) => setNom(e.target.value)}
                  placeholder="Votre nom..."
                  onFocus={(e) => (e.target.style.border = "1.5px solid #FFC300")}
                  onBlur={(e)  => (e.target.style.border = "1.5px solid #e2e8f0")}
                />
              </div>
              <div style={S.formGroup}>
                <label style={S.label}>Téléphone</label>
                <input
                  style={S.input}
                  value={tele}
                  onChange={(e) => setTele(e.target.value)}
                  placeholder="+212..."
                  onFocus={(e) => (e.target.style.border = "1.5px solid #FFC300")}
                  onBlur={(e)  => (e.target.style.border = "1.5px solid #e2e8f0")}
                />
              </div>
            </div>
            <div style={S.row}>
              <div style={S.formGroup}>
                <label style={S.label}>Adresse</label>
                <input
                  style={S.input}
                  value={adresse}
                  onChange={(e) => setAdresse(e.target.value)}
                  placeholder="Adresse complète..."
                  onFocus={(e) => (e.target.style.border = "1.5px solid #FFC300")}
                  onBlur={(e)  => (e.target.style.border = "1.5px solid #e2e8f0")}
                />
              </div>
              <div style={S.formGroup}>
                <label style={S.label}>ICE</label>
                <input
                  style={S.input}
                  value={ice}
                  onChange={(e) => setIce(e.target.value)}
                  placeholder="ICE..."
                  onFocus={(e) => (e.target.style.border = "1.5px solid #FFC300")}
                  onBlur={(e)  => (e.target.style.border = "1.5px solid #e2e8f0")}
                />
              </div>
            </div>

            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "8px" }}>
              <button style={S.saveBtn} onClick={handleSave} disabled={saving}>
                {saving
                  ? <><span className="spinner-border spinner-border-sm" /> Enregistrement...</>
                  : <><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" /><polyline points="17 21 17 13 7 13 7 21" /><polyline points="7 3 7 8 15 8" /></svg> Enregistrer</>}
              </button>
            </div>
          </div>
        </div>

        {/* ── READ-ONLY INFO ── */}
        <div style={S.card}>
          <div style={S.cardHead}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#FFC300" strokeWidth="2.5">
              <circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" />
            </svg>
            Informations du compte
          </div>
          <div style={S.cardBody}>
            <div style={S.row}>
              <div style={S.formGroup}>
                <label style={S.label}>Email</label>
                <div style={S.inputReadOnly}>{email || "—"}</div>
              </div>
              <div style={S.formGroup}>
                <label style={S.label}>Magasin lié</label>
                <div style={S.inputReadOnly}>{magasinLie || "—"}</div>
              </div>
            </div>
            <div style={S.row}>
              <div style={S.formGroup}>
                <label style={S.label}>Solde disponible</label>
                <div
                  style={{
                    ...S.inputReadOnly,
                    background: "linear-gradient(135deg,#1a1a2e,#16213e)",
                    color: "#FFC300",
                    fontWeight: 800,
                    fontSize: "1.05rem",
                  }}
                >
                  {solde != null ? solde.toLocaleString("fr-FR", { minimumFractionDigits: 2 }) + " MAD" : "—"}
                </div>
              </div>
              <div style={S.formGroup}>
                <label style={S.label}>Remise globale</label>
                <div style={S.inputReadOnly}>{remise != null ? remise + " %" : "—"}</div>
              </div>
            </div>
          </div>
        </div>

        {/* ── SECURITY ── */}
        <div style={S.card}>
          <div style={S.cardHead}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#FFC300" strokeWidth="2.5">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" />
            </svg>
            Sécurité
          </div>
          <div style={S.cardBody}>
            {/* Email change button */}
            <div
              role="button"
              tabIndex={0}
              onClick={() => setShowEmailModal(true)}
              onKeyDown={(e) => e.key === 'Enter' && setShowEmailModal(true)}
              style={{ ...S.linkBtn, cursor: 'pointer' }}
              onMouseOver={(e) => (e.currentTarget.style.background = "#f8fafc")}
              onMouseOut={(e)  => (e.currentTarget.style.background = "#fff")}
            >
              <span style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <span style={{ width: "36px", height: "36px", borderRadius: "10px", background: "#f1f5f9", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#64748b" strokeWidth="2.5">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><polyline points="22,6 12,13 2,6" />
                  </svg>
                </span>
                <span>
                  <div style={{ fontWeight: 600, fontSize: "0.9rem" }}>Changer l'adresse email</div>
                  <div style={{ fontSize: "0.78rem", color: "#94a3b8" }}>{email || '—'}</div>
                </span>
              </span>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2.5">
                <polyline points="9 18 15 12 9 6" />
              </svg>
            </div>

            {/* Password change button */}
            <div
              role="button"
              tabIndex={0}
              onClick={() => setShowPasswordModal(true)}
              onKeyDown={(e) => e.key === 'Enter' && setShowPasswordModal(true)}
              style={{ ...S.linkBtn, cursor: 'pointer' }}
              onMouseOver={(e) => (e.currentTarget.style.background = "#f8fafc")}
              onMouseOut={(e)  => (e.currentTarget.style.background = "#fff")}
            >
              <span style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <span style={{ width: "36px", height: "36px", borderRadius: "10px", background: "#f1f5f9", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#64748b" strokeWidth="2.5">
                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" />
                  </svg>
                </span>
                <span>
                  <div style={{ fontWeight: 600, fontSize: "0.9rem" }}>Changer le mot de passe</div>
                  <div style={{ fontSize: "0.78rem", color: "#94a3b8" }}>••••••••</div>
                </span>
              </span>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2.5">
                <polyline points="9 18 15 12 9 6" />
              </svg>
            </div>
          </div>
        </div>
      </div>

      {/* ── Modal: change email ── */}
      {showEmailModal && (
        <div className="cl-security-modal-overlay" style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0,0,0,0.55)', zIndex: 2000, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <div className="cl-security-modal-card" style={{ background: '#fff', padding: '28px 28px 24px', borderRadius: '14px', width: '420px', maxWidth: '92%', boxShadow: '0 8px 40px rgba(0,0,0,0.18)' }}>
            <h3 style={{ margin: '0 0 8px', fontSize: '1.15rem', fontWeight: 700 }}>Changer l'adresse email</h3>
            <p style={{ fontSize: '0.88rem', color: '#64748b', marginBottom: '20px', lineHeight: 1.5 }}>
              Cette demande sera soumise à l'administrateur pour validation. Vous recevrez une notification une fois approuvée.
            </p>
            <label style={{ fontWeight: 600, fontSize: '0.82rem', color: '#64748b', marginBottom: '6px', display: 'block' }}>Nouvelle adresse email</label>
            <input
              type="email"
              value={newEmailInput}
              onChange={(e) => setNewEmailInput(e.target.value)}
              placeholder="ex: nouveau@email.com"
              style={{ width: '100%', padding: '10px 14px', border: '1.5px solid #e2e8f0', borderRadius: '8px', fontSize: '0.92rem', marginBottom: '20px', outline: 'none', boxSizing: 'border-box' }}
            />
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
              <button
                onClick={() => { setShowEmailModal(false); setNewEmailInput(''); }}
                style={{ padding: '9px 20px', borderRadius: '8px', border: '1.5px solid #e2e8f0', background: '#f8fafc', color: '#64748b', fontWeight: 600, cursor: 'pointer', fontSize: '0.9rem' }}
              >Annuler</button>
              <button
                onClick={() => handleSecurityRequest('change-email')}
                disabled={submittingSecurity || !newEmailInput.trim()}
                style={{ padding: '9px 20px', borderRadius: '8px', border: 'none', background: '#FFC300', color: '#1a1a2e', fontWeight: 700, cursor: 'pointer', fontSize: '0.9rem', opacity: (!newEmailInput.trim() || submittingSecurity) ? 0.6 : 1 }}
              >{submittingSecurity ? 'Envoi...' : 'Envoyer la demande'}</button>
            </div>
          </div>
        </div>
      )}

      {/* ── Modal: change password ── */}
      {showPasswordModal && (
        <div className="cl-security-modal-overlay" style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0,0,0,0.55)', zIndex: 2000, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <div className="cl-security-modal-card" style={{ background: '#fff', padding: '28px 28px 24px', borderRadius: '14px', width: '420px', maxWidth: '92%', boxShadow: '0 8px 40px rgba(0,0,0,0.18)' }}>
            <h3 style={{ margin: '0 0 8px', fontSize: '1.15rem', fontWeight: 700 }}>Changer le mot de passe</h3>
            <p style={{ fontSize: '0.88rem', color: '#64748b', marginBottom: '20px', lineHeight: 1.5 }}>
              Cette demande sera soumise à l'administrateur pour validation. Votre nouveau mot de passe sera communiqué une fois approuvé.
            </p>
            <label style={{ fontWeight: 600, fontSize: '0.82rem', color: '#64748b', marginBottom: '6px', display: 'block' }}>Nouveau mot de passe</label>
            <input
              type="password"
              value={newPasswordInput}
              onChange={(e) => setNewPasswordInput(e.target.value)}
              placeholder="Entrez votre nouveau mot de passe"
              style={{ width: '100%', padding: '10px 14px', border: '1.5px solid #e2e8f0', borderRadius: '8px', fontSize: '0.92rem', marginBottom: '20px', outline: 'none', boxSizing: 'border-box' }}
            />
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
              <button
                onClick={() => { setShowPasswordModal(false); setNewPasswordInput(''); }}
                style={{ padding: '9px 20px', borderRadius: '8px', border: '1.5px solid #e2e8f0', background: '#f8fafc', color: '#64748b', fontWeight: 600, cursor: 'pointer', fontSize: '0.9rem' }}
              >Annuler</button>
              <button
                onClick={() => handleSecurityRequest('change-mot-de-passe')}
                disabled={submittingSecurity || !newPasswordInput.trim()}
                style={{ padding: '9px 20px', borderRadius: '8px', border: 'none', background: '#FFC300', color: '#1a1a2e', fontWeight: 700, cursor: 'pointer', fontSize: '0.9rem', opacity: (!newPasswordInput.trim() || submittingSecurity) ? 0.6 : 1 }}
              >{submittingSecurity ? 'Envoi...' : 'Envoyer la demande'}</button>
            </div>
          </div>
        </div>
      )}

      <style>{`
        @keyframes slideInRight {
          from { opacity: 0; transform: translateX(40px); }
          to   { opacity: 1; transform: translateX(0); }
        }

        @media (max-width: 768px) {
          .cl-setting-wrapper {
            padding-bottom: 100px !important;
          }
          .cl-setting-inner {
            padding-top: 16px !important;
          }
          
          /* Make the modals Bottom Sheets on mobile */
          .cl-security-modal-overlay {
            align-items: flex-end !important;
            padding: 0 !important;
          }
          .cl-security-modal-card {
            width: 100% !important;
            max-width: 100% !important;
            border-radius: 20px 20px 0 0 !important;
            margin: 0 !important;
            animation: cl-slide-up 0.3s cubic-bezier(0.22, 1, 0.36, 1) both !important;
            padding-bottom: env(safe-area-inset-bottom, 24px) !important;
          }
        }
        @keyframes cl-slide-up {
          from { transform: translateY(100%); }
          to { transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}